import { CardContent } from '@mui/material';
import PodcastContentTable from 'components/PodcastContentTable';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import {
  useAllPodcastsSocialShareInfo,
  SocialSharePodcasts,
} from 'pages/headliner/state';

import Simplebar from 'simplebar-react';
import PodcastsMobileList from './PodcastsMobileList';
import columns from './utils';

type VideosByPodcastTableProps = {
  onRowClick?: (val: SocialSharePodcasts) => void;
};

const VideosByPodcastTable: React.FC<VideosByPodcastTableProps> = ({
  onRowClick,
}) => {
  const { data: allPodcastData, isLoading } = useAllPodcastsSocialShareInfo();
  const isMobile = useMobileBreakpoint('md');

  return isMobile ? (
    <PodcastsMobileList onClick={onRowClick} />
  ) : (
    <CardContent component={Simplebar}>
      <PodcastContentTable<SocialSharePodcasts>
        columns={columns}
        podcastData={allPodcastData ?? []}
        isLoading={isLoading}
        tableLayout="fixed"
        onRowClick={onRowClick}
      />
    </CardContent>
  );
};
export default VideosByPodcastTable;
